module.exports = __webpack_public_path__ + "static/img/ithelp0.8b24e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/ithelp/ithelp0.jpg
// module id = 9WCP
// module chunks = 1